export default {
  default: "0px 2px 15px 0 rgba(0,0,0,0.21)",
}
